import axiosOriginal from 'axios';

import { axios } from '@vyce/core/src/api';

import { LoginData, ResetPassword, StatusMessage, Token } from '../types';
import config from '../config';

const URL = `${config.gatewayApiUrl}`;

export const checkApiRequest = () => {
  return axios.get('/');
};

/**
 * Exchange the refresh token for a brand-new token pair.
 * Uses a RAW axios call (not the shared instance) so it never carries the
 * expired access token and can't recurse through the 401 interceptor.
 */
export const refreshTokenRequest = (refresh_token: string) => {
  return axiosOriginal.post<Token>(
    `${URL}/public/v1/auth/refresh`,
    { refresh_token },
    { headers: { 'Content-Type': 'application/json' } }
  );
};

/**
 * Blocklist the access token and revoke the whole refresh-token session.
 * Goes through the shared instance so the Bearer header is attached.
 */
export const logoutRequest = (refresh_token: string) => {
  return axios.post<StatusMessage>(`${URL}/public/v1/auth/logout`, { refresh_token });
};

export const loginRequest = (data: LoginData) => {
  return axios.post<Token>(
    `${URL}/public/v1/auth/access-token`,
    {
      username: data.username,
      password: data.password,
      client_secret: data.client_secret,
    },
    {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    }
  );
};

export const verifyEmailRequest = (token: string) => {
  return axios.get<StatusMessage>(`${URL}/public/v1/auth/verify_email/${token}`);
};

export const sendEmailVerificationRequest = ({
  userId,
  ...rest
}: {
  userId: string;
  recaptcha_token: string;
}) => {
  return axios.post<StatusMessage>(`${URL}/public/v1/auth/emails/verification`, rest);
};

export const sendVerificationSMSRequest = (data: { recaptcha_token: string }) => {
  return axios.post<StatusMessage>(`${URL}/public/v1/auth/phone/send_verification_sms`, data);
};

export const redeemVerificationCodeRequest = (code: number) => {
  return axios.post<StatusMessage>(`${URL}/public/v1/auth/phone/redeem_verification_code`, { code });
};

export const sendEmailResetPasswordRequest = ({
  email,
  recaptcha_token,
}: {
  email: string;
  recaptcha_token: string;
}) => {
  return axios.post<StatusMessage>(
    `${URL}/public/v1/auth/send_email_reset_password?recaptcha_token=${recaptcha_token}`,
    {
      recaptcha_token,
      email,
    }
  );
};

export const resetPasswordRequest = (data: ResetPassword) => {
  return axios.post<StatusMessage>(
    `${URL}/public/v1/auth/reset_password?recaptcha_token=${data.recaptcha_token}`,
    data
  );
};
